var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4E3B\u6570\u636E\u7533\u8BF7-\u6570\u636E\u5206\u6790-04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0903\\u4FEE\\u6539",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237\\u5206\\u5C42",
    transform: "translate(-349.000000, -646.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(320.000000, 552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237\\u540D\\u5355\\u5907\\u4EFD-4",
    transform: "translate(13.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E3B\\u6570\\u636E\\u7533\\u8BF7-\\u6570\\u636E\\u5206\\u6790-04",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34,11.4333333 L9.34,13.86 L10.66,13.86 L10.66,9.89 L9.34,9.89 L9.34,11.4333333 Z M11.9933333,9.22333334 L11.9933333,13.86 L13.3066667,13.86 L13.3066667,7.68333334 L11.9933333,7.68333334 L11.9933333,9.22333334 Z M6.69333334,12.1 L8.01,12.1 L8.01,13.86 L6.69333334,13.86 L6.69333334,12.1 Z",
    id: "\\u5F62\\u72B6",
    fill: "#B5B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.61,3.94 L14.5333333,0.86333334 C14.4066667,0.73666668 14.2366667,0.66666666 14.06,0.66666666 L3.58,0.66666666 C2.81333334,0.66666666 2.19333334,1.28666666 2.19333334,2.05333334 L2.19333334,17.9433333 C2.19333334,18.71 2.81333334,19.33 3.58,19.33 L16.4166667,19.33 C17.1833333,19.33 17.8034472,18.71 17.8034472,17.9433333 L17.8034472,4.41 C17.8066667,4.23666666 17.7366667,4.06666666 17.61,3.94 Z M14.4166667,15.1933333 L5.58,15.1933333 C5.21333334,15.1933333 4.91333334,14.8933333 4.91333334,14.5266667 C4.91333334,14.2366667 5.09666668,13.9933333 5.35666666,13.9 L5.35666666,11.4333333 C5.35666666,11.0666667 5.65666666,10.7666667 6.02333334,10.7666667 L8.00666666,10.7666667 L8.00666666,9.22333334 C8.00666666,8.85666668 8.30666666,8.55666668 8.67333334,8.55666666 L10.6566667,8.55666666 L10.6566667,7.01333334 C10.6566667,6.64666668 10.9566667,6.34666666 11.3233333,6.34666666 L13.9733333,6.34666666 C14.34,6.34666666 14.64,6.64666666 14.64,7.01333334 L14.64,13.9 C14.8966667,13.9933333 15.0833333,14.2366667 15.0833333,14.5266667 C15.0833333,14.8933333 14.7833333,15.1933333 14.4166667,15.1933333 Z",
    id: "\\u5F62\\u72B6",
    fill: "#E9E9EE"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a01caa20.svg";
export { ForwardRef as ReactComponent };